
import { REG_PHONE, REG_AMT, REG_NUM, REG_ID_CARD, REG_P_INT } from './regExp';

// 必填
export const validatePhone = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入电话号码'));
  } else {
    if (!REG_PHONE.test(value)) {
      callback(new Error('请输入正确的电话号码'));
    }
    callback();
  }
};

// 非必填
export const validatePhoneNoRequired = (rule, value, callback) => {
  if (value === '') {
    callback();
  }
  if (!REG_PHONE.test(value)) {
    callback(new Error('请输入正确的电话号码'));
  }
  callback();
};

// 正整数校验
export const checkNumMain = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入数字'));
  } else {
    if (!REG_P_INT.test(value)) {
      callback(new Error('请输入数字'));
    }
    callback();
  }
};
// 价格
export const checkAmt = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入价格'));
  } else if (!REG_AMT.test(value)) {
    callback(new Error('请输入正确的价格'));
  } else {
    callback();
  }
};

// 数字（两位小数）
export const checkNum = (rule, value, callback) => {
  if (!value) {
    callback();
  } else if (!REG_AMT.test(value)) {
    callback(new Error('请输入数字（两位小数）'));
  } else {
    callback();
  }
};

// 数字（两位小数）必输
export const checkNumMust = (rule, value, callback) => {
  if (!REG_AMT.test(value)) {
    callback(new Error('请输入数字（可输小数）'));
  } else {
    callback();
  }
};

// 价格 非必输
export const checkAmtNull = (rule, value, callback) => {
  if (!value) {
    callback();
  } else if (!REG_AMT.test(value)) {
    callback(new Error('请输入正确的价格'));
  } else {
    callback();
  }
};

// 成分数量
export const checkNumMore = (rule, value, callback) => {
  if (!value) {
    callback();
  } else if (!REG_NUM.test(value)) {
    callback(new Error('请输入正确的成分数量'));
  } else {
    callback();
  }
};

// 身份证 非必输
export const checkIDCard = (rule, value, callback) => {
  if (!value) {
    callback();
  } else if (!REG_ID_CARD.test(value)) {
    callback(new Error('请输入正确的身份证'));
  } else {
    callback();
  }
};

// 校验手机号
export const checkTel = (rule, value, callback) => {
  const reg = /^\d{11}$/;
  if (!value) {
    callback(new Error('请填写手机号'));
  } else if (!reg.test(value)) {
    callback(new Error('请输入正确的手机号格式'));
  } else {
    callback();
  }
};

// 校验年龄
export const checkYear = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请填写年龄！'));
  } else if (!REG_P_INT.test(value)) {
    callback(new Error('请填写正确的年龄！'));
  } else if (value > 999) {
    callback(new Error('请填写正确的年龄！'));
  } else {
    callback();
  }
};

// 校验月份
export const checkMonth = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请填写月份！'));
  } else if (!REG_P_INT.test(value)) {
    callback(new Error('请填写数字！'));
  } else if (value > 11) {
    callback(new Error('小于11的月份！'));
  } else {
    callback();
  }
};

// 校验天
export const checkDay = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请填写天数！'));
  } else if (!REG_P_INT.test(value)) {
    callback(new Error('请填写数字！'));
  } else if (value > 30) {
    callback(new Error('小于30的天数！'));
  } else {
    callback();
  }
};

export default {
  validatePhone,
  checkAmt,
  checkAmtNull,
  checkNumMust,
  checkNumMore,
  checkIDCard,
  checkNum,
  checkNumMain,
  checkTel,
  checkYear,
  checkMonth,
  checkDay,
};
